import { Body, Button, colors, Image, Spacer } from '@spritz-finance/ui'
import { useNavigate } from 'react-router-dom'
import { Column } from '../../../../components/Layout/Column'
import { ThemedHeroImage } from '../../../../components/ThemedHeroImage'

export const NoPaymentsInProgress = () => {
    const navigate = useNavigate()
    return (
        <Column align="center">
            <Spacer height={48} />
            <Body.SmBold size={16} secondary>
                No payments in progress
            </Body.SmBold>
            <Spacer height={16} />
            <Body.SmBold size={14} color={colors.medGrey}>
                Once you make a payment, it will show up here until it settles in your account
            </Body.SmBold>
            <Spacer height={48} />
            <ThemedHeroImage>
                <Image.SchedulePayment width={300} />
            </ThemedHeroImage>
            <Spacer height={48} />
            <Button.CTA onClick={() => navigate('/bills/main')}>Go to bills</Button.CTA>
        </Column>
    )
}
